'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingId$() {
  this.c6K = null;
  this.c6L = false;
  this.c6I = null;
  this.c6J = false;
}
export { $c_Lpresto_types$GroupingId$ as $c_Lpresto_types$GroupingId$ };
$p = $c_Lpresto_types$GroupingId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingId$;
/** @constructor */
function $h_Lpresto_types$GroupingId$() {
}
export { $h_Lpresto_types$GroupingId$ as $h_Lpresto_types$GroupingId$ };
$h_Lpresto_types$GroupingId$.prototype = $p;
$p.SA = (function() {
  if ((!this.c6L)) {
    this.c6K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.c6L = true;
  }
  return this.c6K;
});
$p.nL = (function() {
  if ((!this.c6J)) {
    this.c6I = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.c6J = true;
  }
  return this.c6I;
});
var $d_Lpresto_types$GroupingId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingId$, "presto.types$GroupingId$", ({
  a0F: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingId$ as $d_Lpresto_types$GroupingId$ };
var $n_Lpresto_types$GroupingId$;
function $m_Lpresto_types$GroupingId$() {
  if ((!$n_Lpresto_types$GroupingId$)) {
    $n_Lpresto_types$GroupingId$ = new $c_Lpresto_types$GroupingId$();
  }
  return $n_Lpresto_types$GroupingId$;
}
export { $m_Lpresto_types$GroupingId$ as $m_Lpresto_types$GroupingId$ };
//# sourceMappingURL=presto.types$-Grouping-Id$.js.map
